import { useEnvironmentContext } from '@openeducation/oe-rn-providers/src/environment/environment.provider';
import {
  FeedbackResponseDTO,
  LiveClassFeedbackService,
} from '@openeducation/oe-rn-services';
import { useQuery } from 'react-query';

export interface UseLiveClassFeedbackByUUIDProps {
  feedbackUUID?: string;
}

export const useLiveClassFeedbackByUUID = ({
  feedbackUUID,
}: UseLiveClassFeedbackByUUIDProps) => {
  const { environment } = useEnvironmentContext();

  const {
    data: liveClassFeedback,
    isLoading: isLoadingLiveClassFeedbackByUUID,
    isError: isErrorLiveClassFeedbackByUUID,
  } = useQuery<FeedbackResponseDTO>(
    ['liveClassFeedbackById', feedbackUUID],
    () =>
      LiveClassFeedbackService.getLiveClassFeedbackByUUID(
        environment,
        feedbackUUID
      ),
    {
      enabled: !!feedbackUUID,
    }
  );

  return {
    liveClassFeedback,
    isLoadingLiveClassFeedbackByUUID,
    isErrorLiveClassFeedbackByUUID,
  };
};
